export const SET_KEYBOARD_CLOSE = 'SET_KEYBOARD_CLOSE';
export const SET_KEYBOARD_OPEN = 'SET_KEYBOARD_OPEN'

